<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="titulo-modal">
            Deseja excluir {{ descricaoGrupoSelecionado }}?
          </span>
        </v-card-title>
        <v-card-text>
          <span class="fontsize-descricao"
            >Ao confirmar essa opção você estará excluindo o grupo.</span
          >
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="white"
            class="btn-primary ml-0 mb-3"
            text
            @click="excluirGrupo"
          >
            <v-progress-circular
              indeterminate
              v-if="carregando"
              color="white"
              :size="25"
              :width="3"
            ></v-progress-circular>
            <div v-else>Sim</div>
          </v-btn>
          <v-btn
            color="primary"
            class="btn-quaternary ml-0 mb-3"
            text
            @click="$emit('fecharModal')"
          >
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
  
  <script>
import Grupo from "@/model/grupo/Grupo";
import grupoService from "@/api/grupo/grupo-api";

export default {
  props: {
    idGrupoSelecionado: { type: Number, require: true },
    descricaoGrupoSelecionado: { type: String, require: true },
  },
  data() {
    return {
      dialog: true,
      carregando: false,
    };
  },
  methods: {
    async excluirGrupo() {
      this.carregando = true;

      let grupo = new Grupo();
      grupo.id = this.idGrupoSelecionado;

      await grupoService
        .excluir(this.idGrupoSelecionado)
        .then(() => {
          this.carregando = false;
          this.$emit("excluirGrupo", grupo.id);
        })
        .catch((error) => {
          this.carregando = false;
          this.$emit(
            "erroExcluirGrupo",
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
              "Não foi possível se comunicar com o servidor!"
          );
        });
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.fontsize-descricao {
  font-size: 1.1rem;
}
</style>
  